// extracted by mini-css-extract-plugin
export default {"container":"ExternalNavigationDialog_container_fc51e","externalLink":"ExternalNavigationDialog_externalLink_e86c7"};